module.exports = __webpack_public_path__ + "static/media/bgBlueRightMAILogo.4e6715b9.png";